import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import './DeveloperProfile.css';

const DeveloperProfile: React.FC = () => {
  const { t } = useLanguage();

  return (
    <div className="developer-profile">
      <div className="profile-hero">
        <div className="profile-image">
          <div className="avatar-placeholder">TS</div>
        </div>
        <div className="profile-info">
          <h2>Tobias Stumpf</h2>
          <p className="title">Software Developer & IoT Specialist</p>
          <p className="location">📍 Mannheim, Germany</p>
        </div>
      </div>

      <div className="profile-sections">
        <section className="about-section">
          <h3>{t('profile.about.title')}</h3>
          <p>
            {t('profile.about.intro')}
          </p>
          <p>
            {t('profile.about.focus')}
          </p>
        </section>

        <section className="experience-section">
          <h3>{t('profile.experience.title')}</h3>
          <div className="experience-item">
            <div className="experience-header">
              <h4>{t('profile.experience.iot.title')}</h4>
              <span className="duration">{t('profile.experience.iot.period')}</span>
            </div>
            <p className="company">{t('profile.experience.iot.company')}</p>
            <ul>
              <li>{t('profile.experience.iot.task1')}</li>
              <li>{t('profile.experience.iot.task2')}</li>
              <li>{t('profile.experience.iot.task3')}</li>
            </ul>
          </div>
          
          <div className="experience-item">
            <div className="experience-header">
              <h4>{t('profile.experience.fullstack.title')}</h4>
              <span className="duration">{t('profile.experience.fullstack.period')}</span>
            </div>
            <p className="company">{t('profile.experience.fullstack.company')}</p>
            <ul>
              <li>{t('profile.experience.fullstack.task1')}</li>
              <li>{t('profile.experience.fullstack.task2')}</li>
              <li>{t('profile.experience.fullstack.task3')}</li>
              <li>{t('profile.experience.fullstack.task4')}</li>
            </ul>
          </div>
        </section>

        <section className="projects-section">
          <h3>{t('profile.projects.title')}</h3>
          <div className="project-grid">
            <div className="project-card">
              <div className="project-header">
                <h4>{t('profile.projects.iot.title')}</h4>
                <div className="project-status">{t('profile.projects.status.completed')}</div>
              </div>
              <p>{t('profile.projects.iot.description')}</p>
              <div className="project-tech">
                <span className="tech-tag">Python</span>
                <span className="tech-tag">IoT</span>
                <span className="tech-tag">MQTT</span>
                <span className="tech-tag">Redis</span>
              </div>
              <div className="project-links">
                <button className="project-link-btn" disabled>{t('profile.projects.private')}</button>
              </div>
            </div>

            <div className="project-card">
              <div className="project-header">
                <h4>{t('profile.projects.webapp.title')}</h4>
                <div className="project-status ongoing">{t('profile.projects.status.ongoing')}</div>
              </div>
              <p>{t('profile.projects.webapp.description')}</p>
              <div className="project-tech">
                <span className="tech-tag">React</span>
                <span className="tech-tag">TypeScript</span>
                <span className="tech-tag">Node.js</span>
                <span className="tech-tag">PostgreSQL</span>
              </div>
              <div className="project-links">
                <button className="project-link-btn demo">{t('profile.projects.demo')}</button>
              </div>
            </div>

            <div className="project-card">
              <div className="project-header">
                <h4>{t('profile.projects.automation.title')}</h4>
                <div className="project-status">{t('profile.projects.status.completed')}</div>
              </div>
              <p>{t('profile.projects.automation.description')}</p>
              <div className="project-tech">
                <span className="tech-tag">Java</span>
                <span className="tech-tag">Spring Boot</span>
                <span className="tech-tag">Docker</span>
                <span className="tech-tag">Jenkins</span>
              </div>
              <div className="project-links">
                <button className="project-link-btn" disabled>{t('profile.projects.private')}</button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default DeveloperProfile;